<appTable v-if="shouldRenderConfig && getIsSummaryPageOptionActive" :tableName="name"  v-bind:tableClass="getClassName">
    <div v-bind:class="getClassName">
        <div
            v-bind:class="getClassNameContainer"
            v-for="(item,index) in getSummarySelectedPageOptions"
            v-bind:key="index">        
            <div v-if="getSummarySelectedPageOptions.length > 1" v-bind:class="getClassName + 'Header'">
                {{item.name}}
            </div>
            <div
                v-bind:class="getClassNameItem"
                v-for="(attribute,index) in item.data"
                v-bind:key="index">
                <div v-bind:class="getClassNameItem + 'Idx'">{{index}}</div>
                <div v-bind:class="getClassNameItem + 'Value'">{{attribute}}</div>
                <div class="matrix_separator"></div>
            </div>
        </div>        
    </div>
</appTable>